import { forwardRef, type Ref, type SVGProps } from "react";

function SvgNewJobs(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 176 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M69.9659 40.7778H61.9506C55.3106 40.7778 49.9277 46.0757 49.9277 52.6111V84.1667C49.9277 90.702 55.3106 96 61.9506 96H114.05C120.69 96 126.073 90.702 126.073 84.1667V52.6111C126.073 46.0757 120.69 40.7778 114.05 40.7778H106.035M69.9659 40.7778V36.8333C69.9659 30.298 75.3487 25 81.9888 25H94.0116C100.652 25 106.035 30.298 106.035 36.8333V40.7778M69.9659 40.7778H106.035"
        stroke="url(#paint0_linear_1214_7018)"
        strokeWidth="10"
      />
      <path
        d="M37.975 12.975C37.975 12.4365 37.5385 12 37 12C36.4615 12 36.025 12.4365 36.025 12.975C36.025 17.0313 35.1297 19.7294 33.4296 21.4296C31.7294 23.1297 29.0313 24.025 24.975 24.025C24.4365 24.025 24 24.4615 24 25C24 25.5385 24.4365 25.975 24.975 25.975C29.0313 25.975 31.7294 26.8703 33.4296 28.5704C35.1297 30.2706 36.025 32.9687 36.025 37.025C36.025 37.5635 36.4615 38 37 38C37.5385 38 37.975 37.5635 37.975 37.025C37.975 32.9687 38.8703 30.2706 40.5704 28.5704C42.2706 26.8703 44.9687 25.975 49.025 25.975C49.5635 25.975 50 25.5385 50 25C50 24.4615 49.5635 24.025 49.025 24.025C44.9687 24.025 42.2706 23.1297 40.5704 21.4296C38.8703 19.7294 37.975 17.0313 37.975 12.975Z"
        fill="#0D2B57"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1214_7018"
          x1="88.0002"
          y1="25"
          x2="88.0002"
          y2="96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgNewJobs);
export default ForwardRef;
